module.exports = __webpack_public_path__ + "static/img/logo_d.feb18ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_d.png
// module id = 6GBD
// module chunks = 0